// API location, from VITE_API_BASE_URL in .env (dev) / .env.production (build).
// Falls back to the same-origin /api/client, which the Vite dev proxy or an
// nginx /api proxy forwards to the dashboard API.
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '/api/client').replace(/\/+$/, '')

// Origin of the API (e.g. https://remote.byredstone.com, or '' when the API
// is same-origin). The API returns media as root-relative paths such as
// /api/client/recordings/1/audio, so those are prefixed with this.
export const API_ORIGIN = /^https?:\/\//.test(API_BASE_URL) ? new URL(API_BASE_URL).origin : ''

// Turn an API-relative media path into a playable URL; absolute URLs pass through.
export const apiUrl = (path) => (!path || /^https?:\/\//.test(path) ? path : `${API_ORIGIN}${path}`)
